/**
 * E-Store FrontOffice Application
 * Page d'accueil = Catalogue (comme Amazon/BackMarket)
 */

import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { ResetPasswordPage } from './pages/ResetPasswordPage';
import { VerifyEmailPage } from './pages/VerifyEmailPage';
import { CatalogPage } from './pages/CatalogPage';
import { ProductDetailPage } from './pages/ProductDetailPage';
import { CartPage } from './pages/CartPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { MyAccountPage } from './pages/MyAccountPage';
import { MyOrdersPage } from './pages/MyOrdersPage';
import { FAQPage } from './pages/FAQPage';
import { enterpriseApi, ChatWidgetLauncher, getBrandInfo } from '@e-store/shared';
import { useAnalytics } from './hooks/useAnalytics';

function App() {
  // Tracking analytics (RGPD compliant)
  useAnalytics();

  // Titre et meta description: marque détectée via le domaine, puis nom configuré via l'API
  useEffect(() => {
    const applyStoreName = (storeName: string) => {
      document.title = storeName;
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', `${storeName} - Boutique en ligne`);
      }
    };

    applyStoreName(getBrandInfo().name);

    const loadStoreName = async () => {
      try {
        const response = await enterpriseApi.getPublicInfo();
        if (response.data?.name) {
          applyStoreName(response.data.name);
        }
      } catch (error) {
        console.error('Failed to load store name:', error);
        // Garder le titre détecté via le domaine en cas d'erreur
      }
    };

    loadStoreName();
  }, []);

  return (
    <>
    <Routes>
      {/* Page d'accueil = Catalogue (comme Amazon/BackMarket) */}
      <Route path="/" element={<CatalogPage />} />
      <Route path="/catalog" element={<CatalogPage />} />
      <Route path="/product/:id" element={<ProductDetailPage />} />
      <Route path="/cart" element={<CartPage />} />
      <Route path="/checkout" element={<CheckoutPage />} />
      <Route path="/my-account" element={<MyAccountPage />} />
      <Route path="/orders" element={<MyOrdersPage />} />
      <Route path="/faq" element={<FAQPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/verify-email" element={<VerifyEmailPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>

    {/* Chatbot guide utilisateur */}
    <ChatWidgetLauncher context="frontoffice" />
    </>
  );
}

export default App;
